// Tiny bridge so any screen can ask the Phone Panel to open on its Send Text tab for a lead.

/** Event name the Phone Panel listens for. */
export const OPEN_TEXT_EVENT = 'civix:phone:text';

/**
 * Open the Phone Panel on "Send Text" with the recipient filled in.
 * @param {{phone: string, leadId?: string, name?: string}} detail
 */
export function openTextComposer(detail) {
  window.dispatchEvent(new CustomEvent(OPEN_TEXT_EVENT, { detail }));
}
